import { V3Record } from 'data/helpers/V3Record.js'

export const Follow = V3Record('follow', {
  userId: null, // integer
  itemId: null, // integer
  itemType: null, // string
  level: null // string
})
